"use client";

import { fetchGetCompanySubsidiaries } from "@/services/api";
import { useState, useEffect } from "react";

export default function ContactUsMapArea({ company }) {

    const [subsidiaries, setSubsidiaries] = useState([])
    useEffect(() => {
        fetchGetCompanySubsidiaries()
            .then(res => {
                const subs = res.map(item => ({
                    city: item.addressCity,
                    federativeUnit: item.addressFederativeUnit,
                    postalCode: item.addressPostalCode,
                    address: item.addressStreet
                }))
                setSubsidiaries(subs)
            })
    }, [])

    return (
        <section className="bg-white-light">
            <div className="auto-container">
                <div className="row">
                    <div className="col-md-12 wow fadeIn">
                        <div className="row">
                            <div className="col-md-12 theme-mb-30 pagemapa">
                                <iframe src={`https://maps.google.com/maps?q=${company.address} - ${company.city} - ${company.federativeUnit} - ${company.postalCode}&t=&z=13&ie=UTF8&iwloc=&output=embed`} width="100%" height="500" style={{ border: '0' }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                            </div>
                            <div className="col-md-12 text-center info-contact">
                                <i className="mdi mdi-map-marker icon-title"></i>
                                <p>{`${company.address} - ${company.city} - ${company.federativeUnit} - CEP: ${company.postalCode}`}</p>
                                <ul className="social-icons color-hover social-icons-large theme-mt-30">
                                    <li className="social-google-maps">
                                        <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(company.address + ', ' + company.city + ' - ' + company.federativeUnit)}`} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                            <i className="mdi mdi-google-maps"></i>
                                        </a>
                                    </li>
                                    <li className="social-waze">
                                        <a href={`https://waze.com/ul?q=${encodeURIComponent(`${company.address}, ${company.city}`)}&navigate=yes`} rel="nofollow" target="_blank" title="Como chegar pelo Waze">
                                            <i className="mdi mdi-waze"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {subsidiaries.length > 0 ?
                subsidiaries.map((item, index) => (

                    <div className="auto-container" key={index}>
                        <div className="row">
                            <div className="col-md-12 wow fadeIn">
                                <div className="row">
                                    <div className="col-md-12 theme-mb-30 pagemapa">
                                        <iframe src={`https://maps.google.com/maps?q=${item.address} - ${item.city} - ${item.federativeUnit} - ${item.postalCode}&t=&z=13&ie=UTF8&iwloc=&output=embed`} width="100%" height="500" style={{ border: '0' }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                                    </div>
                                    <div className="col-md-12 text-center info-contact">
                                        <i className="mdi mdi-map-marker icon-title"></i>
                                        <p>{`${item.address} - ${item.city} - ${item.federativeUnit} - CEP: ${item.postalCode}`}</p>
                                        <ul className="social-icons color-hover social-icons-large theme-mt-30">
                                            <li className="social-google-maps">
                                                <a href={`https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(item.address + ', ' + item.city + ' - ' + item.federativeUnit)}`} rel="nofollow" target="_blank" title="Como chegar pelo Google Maps">
                                                    <i className="mdi mdi-google-maps"></i>
                                                </a>
                                            </li>
                                            <li className="social-waze">
                                                <a href={`https://waze.com/ul?q=${encodeURIComponent(`${item.address}, ${item.city}`)}&navigate=yes`} rel="nofollow" target="_blank" title="Como chegar pelo Waze">
                                                    <i className="mdi mdi-waze"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))

                : null}
        </section>
    );
}